import "./StopCard.css";
import React from "react";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";
import { v4 } from "uuid";
import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";
import { NumericFormat } from "react-number-format";
import { getCurrencySymbol } from "../../../../util";

export default function SuggestedStops(props) {
  //   console.log('>>>>>>>>>.item', props.items)
  const navigate = useNavigate();
  return (
    <div>
      <p
        className="body4"
        style={{
          paddingTop: "24px",
          margin: "24px 16px -10px 16px",
          borderTop: "1px solid #E7E9F2",
          color: "var(--gray60)",
        }}
      >
        Similar activities that you may like
      </p>
      <div className="scrolling-wrapper hide-scroll">
        {props.items.map((item) => {
          return (
            <>
              <div
                className="card"
                key={v4()}
                style={{ minWidth: "300px", maxWidth: "80%" }}
              >
                <Card
                  sx={{
                    margin: "10px 10px 0px 0px",
                    //   borderRadius: '8px',
                    border: "none",
                  }}
                  variant="outlined"
                >
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "15px",
                      // justifyContent: "space-around",
                      //   gap: '10px',
                      // alignItems: "center",
                      marginLeft: "16px",
                      //   marginTop: '10px',
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      className="stop-image-item"
                      style={{ marginRight: "15px" }}
                      onClick={() => {
                        props.handleDetailPageOpen(
                          item.item_id,
                          item.is_default
                        );
                        analyticsEvent.clickEvent(
                          "Stays",
                          eventName.Stays_view_item_details,
                          `item_id: ${item.item_id}, item_type: ${item.item_type}, item_name: ${item.display_name}, item_city: ${item.address.city}`
                        );
                      }}
                    >
                      <img
                        style={{
                          borderRadius: "8px",
                          width: "65px",
                          height: "55px",
                          alignSelf: "baseline",
                          marginTop: "15px",
                          cursor: "pointer",
                        }}
                        alt="stop"
                        src={item.images[0].twoX.thumbnail}
                      ></img>
                    </div>
                    <div
                      className="stay-details-item truncated"
                      style={{ marginTop: "8px", cursor: "pointer" }}
                    >
                      <div>
                        <p
                          className="headline2 truncated"
                          onClick={() => {
                            props.handleDetailPageOpen(
                              item.item_id,
                              item.is_default
                            );
                          }}
                        >
                          {item.display_name}
                        </p>
                      </div>
                      <p
                        className="body3 truncated"
                        style={{
                          color: "var(--gray80)",
                          lineHeight: "115%",
                        }}
                      >
                        {item.properties.review.avg_review !== 0 && (
                          <>
                            <span
                              style={{
                                color: "var(--statusSeaweedGreen)",
                              }}
                            >
                              &#9733; {item.properties.review.avg_review + "/5"}
                              &nbsp;
                            </span>
                            <span>&#x2022;</span>
                          </>
                        )}
                        {!isEmpty(item.properties.primary_sub_category) && (
                          <span
                            className="body4"
                            style={{ color: "var(--gray80)" }}
                          >
                            &nbsp;
                            {item.properties.primary_sub_category}
                          </span>
                        )}
                      </p>
                      <p className="body4">
                        {!isEmpty(item.properties.price) && (
                          <span style={{ color: "var(--gray80)" }}>
                            &nbsp;
                            {getCurrencySymbol(item.properties.price[0].unit)}
                            <NumericFormat
                              value={Math.round(item.properties.price[0].value)}
                              thousandsGroupStyle="lakh"
                              thousandSeparator=","
                              displayType="text"
                              renderText={(value) => (
                                <span style={{ color: "var(--gray80)" }}>
                                  {value}
                                </span>
                              )}
                            />
                            <span
                              className="body3"
                              style={{ color: "var(--gray60)" }}
                            >
                              {" "}
                              / person
                            </span>
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
}
